import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ADMIN_API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { 
    SystemSettings, 
    SystemSettingsApiResponse, 
    UpdateSystemSettingsParams,
} from '@INTERFACES/api/system-settings';

function transformSystemSettingsResponse(raw: SystemSettingsApiResponse): SystemSettings {
    return {
        id: raw.id,
        wysiwygApiToken: raw.wysiwyg_api_token,
        wysiwygApiUrl: raw.wysiwyg_api_url,
        systemName: raw.system_name,
        systemVersion: raw.system_version,
        maintenanceMode: raw.maintenance_mode,
        maintenanceMessage: raw.maintenance_message,
        createdAt: raw.created_at,
        updatedAt: raw.updated_at,
    };
}

export const systemSettingsAdminApi = createApi({
    reducerPath: 'system-settings-admin-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + ADMIN_API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['SystemSettings'],
    endpoints: (builder) => ({
        getSystemSettings: builder.query<SystemSettings, void>({
            query: () => '/system-settings/',
            transformResponse(raw: SystemSettingsApiResponse) {
                return transformSystemSettingsResponse(raw);
            },
            providesTags: ['SystemSettings'],
        }),
        updateSystemSettings: builder.mutation<SystemSettings, UpdateSystemSettingsParams>({
            query: (params) => {
                const formData = JSON.stringify(params);

                return {
                    url: '/system-settings/',
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
            },
            transformResponse(raw: SystemSettingsApiResponse) {
                return transformSystemSettingsResponse(raw);
            },
            invalidatesTags: ['SystemSettings'],
        }),
    }),
});

export const {
    
    useUpdateSystemSettingsMutation,
} = systemSettingsAdminApi; 